module.exports = __webpack_public_path__ + "img/labmem_text_title_en.a9bbc087.png";